import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import { useSelector } from "react-redux";
import AdminDashboard from "../pages/admin/AdminDashboard";
import ManageProviders from "../pages/admin/ManageProviders";
import ProviderDetails from "../pages/admin/ProviderDetails";
import AdminMain from "../pages/admin/AdminMain";
import SignUp from "../pages/signUp/SignUp";
import EmailVerification from "../pages/emailVerification/EmailVerification";
import EmailVerifiedGreeting from "../pages/emailVerifiedGreeting/EmailVerifiedGreeting";
import Login from "../pages/login/Login";
import DoctorProfile from "../pages/doctor/DoctorProfile";
import FormSort from "../pages/formSort/openForm/FormSort";
import DoctorDetails from "../pages/admin/DoctorDetails";
import PaymentForm from "../pages/stripe/PaymentForm";
import ManageLeads from "../pages/admin/ManageLeads";
import DoctorDashboard from "../pages/doctor/DoctorDashboard";
import DoctorMain from "../pages/doctor/DoctorMain";
// import DoctorSuggestion from "../components/formSort/DoctorSuggestion";
import PaymentWrapper from "../pages/stripe/PaymentWrapper";
import DoctorSuggestion from "../components/formSort/DoctorSuggestion";
import SignupProvider from "../pages/provider/signupProvider/SignupProvider";
import EditProvider from "../pages/admin/EditProvider";
import { SignupForms } from "../pages/provider/providerSignUp/SignupForms";
import CustomMapLocation from "../pages/formSort/customMapLocation/CustomMapLocation";
import { LeadList } from "../pages/doctor/components/LeadList";
import { PipelineView } from "../pages/doctor/components/PipelineView";
import { Review } from "../pages/doctor/components/Review";
import { Managestaff } from "../pages/doctor/components/Managestaff";
import { Logs } from "../pages/doctor/components/Logs";
import { ProfileStaff } from "../pages/doctor/components/ProfileStaff";
import { Locationprofile } from "../pages/doctor/components/Locationprofile";
import ForgotPassword from "../pages/forgotPassword/ForgotPassword";
import SetPassword from "../pages/setPassword/SetPassword";
import { LeadLists } from "../pages/admin/LeadList";
import { PipelineViews } from "../pages/admin/PipelineView";
import { AdminProfile } from "../pages/admin/AdminProfile";
import { CardsList } from "../pages/admin/CardsList";
import { AdminReview } from "../pages/admin/review/AdminReview";
import { AdminLogs } from "../pages/admin/AdminLogs";
import PdfTemplate from "../pages/doctor/components/PdfTemplate";
import { TransactionInfo } from "../pages/doctor/components/TransactionDetails";
import { TypeFormList } from "../pages/admin/TypeFormList";
import { Notifications } from "../pages/doctor/components/Notifications";
import ScoreScale from "../pages/formSort/scoreScale/ScoreScale";
import PublicRoute from "./PublicRoute";
import LocationDetails from "../pages/doctor/components/LocationDetails";

const AppRoutes = () => {
  const userRole = useSelector((state) => state.auth.role);

  return (
    <>
      <Routes>
        <Route path="/email-verification" element={<EmailVerification />} />
        <Route path="/email-verified" element={<EmailVerifiedGreeting />} />
        <Route path="/" element={<PublicRoute component={Login} />} />
        <Route path="/scale" element={<ScoreScale />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/set-password/:token" element={<SetPassword />} />
        <Route path="/BVDQ" element={<FormSort />} />
        {/* <Route path="/stripe" element={<PaymentForm />} /> */}
        {/* <Route path="/stripe-payment" element={<PaymentWrapper />} /> */}
        <Route path="/list" element={<DoctorSuggestion />} />
        <Route
          path="/custom-map-location/:zipcode/:country_of_residence_/:Enter_firstname/:Enter_lastname/:age/:age_category"
          element={<CustomMapLocation />}
        />
        <Route path="/locationsignup/:providerId" element={<SignupForms />} />
        <Route path="/signup/:providerId" element={<SignupProvider />} />
        <Route path="/page" element={<PdfTemplate />} />

        {(userRole === "doctor" ||
          userRole === "staff" ||
          userRole === "provider" ||
          userRole === "location") && (
          <Route
            path="/:userRole"
            element={<PrivateRoute Component={<DoctorDashboard />} />}
          >
            <Route path=":id" element={<LeadList />} />
            <Route path="pipelineview/:id" element={<PipelineView />} />

            {(userRole === "doctor" ||
              userRole === "provider" ||
              userRole === "location") && (
              <>
                <Route path="reviewsection/:id" element={<Review />} />
                <Route path="managestaff/:id" element={<Managestaff />} />
                <Route path="logs/:id" element={<Logs />} />
                <Route
                  path="location-details/:id"
                  element={<LocationDetails />}
                />
              </>
            )}

            <Route path="profile/:id" element={<ProfileStaff />} />
            <Route path="locationprofile/:id" element={<Locationprofile />} />
            <Route path="trans-details/:id" element={<TransactionInfo />} />
            <Route path="notificaton/:id" element={<Notifications />} />
          </Route>
        )}

        {userRole === "admin" && (
          <Route
            path="/admin/dashboard"
            element={<PrivateRoute Component={<AdminDashboard />} />}
          >
            <Route index element={<AdminMain />} />
            <Route path="manage-providers" element={<ManageProviders />} /> 
            <Route path="doctor/:id" element={<DoctorDetails />} />
            <Route path="provider/:id" element={<ProviderDetails />} />
            <Route path="edit-provider/:id" element={<EditProvider />} />
            <Route path="manage-leads" element={<LeadLists />} />
            <Route path="pipeline-view" element={<PipelineViews />} />
            <Route path="profile" element={<AdminProfile />} />
            <Route path="cardDetails" element={<CardsList />} />
            <Route path="typeform-questions" element={<TypeFormList />} />
            <Route path="reviewsection" element={<AdminReview />} />
            <Route path="logs" element={<AdminLogs />} />
            <Route path="notificaton" element={<Notifications />} />
          </Route>
        )}

         {/* Catch-all unmatched route */}
         <Route path="*" element={<Navigate to="/" replace />} />

      </Routes>
    </>
  );
};

export default AppRoutes;
